<template>
    <div>
        <h2 class="title">{{config.data.label}}</h2>

        <p><router-link :to="{name:'Json',params:{id:config.id}}" target="_blank">
            <button   class="button is-warning is-small"  icon-left="plus-circle-outline">EXPORT JSON: GENERER A PARTIR DE CET ELEMENT</button>
        </router-link></p>
        <p>
        <button v-if="canBeDialogue"
                class="button is-info is-small"
                icon-left="plus-circle-outline"
                @click.prevent="dialoguePanel">
            TRANSFORMER CET ELEMENT EN DIALOGUE
        </button>
        </p>

<hr>






        <form @submit.prevent="validate" @input="saveIt">


            <h2 class="is-size-5">Label</h2>

            <b-input v-model="config.data.label" size="is-small" ref="startFocus"></b-input>
            <h2 class="is-size-5">Description</h2>
            <b-input type="textarea" v-model="config.data.description" has-counter></b-input>

            <hr>
            <h2 class="is-size-5">REQUIS :</h2>

            <carac v-for="(value,key,index) in getReq"
                   :key="value.clef" :objet="value" letype="REQ" :lieu="config.id"
                   @deleteMe="delReq" @reloadMe="reloadMe"></carac>

            <b-collapse :open="false" aria-id="contentIdForA11y1" ref="addrequis" @open="focusReqOn"  @close="focusReqOff">
                <b-button
                        size="is-small"
                        type="is-info"
                        slot="trigger"
                        aria-controls="contentIdForA11y1">
                    <b-icon  icon="plus"></b-icon>
                </b-button>
                <div>
                    <Addcarac :lieu="config.id" @validated="addReq" :open="reqIsOpen" letype="REQ"></Addcarac>
                </div>
            </b-collapse>
        </form>
    </div>
</template>

<script>

    import _ from 'lodash';
    import Addcarac from './AddCarac.vue';
    import Carac from './Carac.vue';

    export default {
        name: 'tabtache',
        data (){
            return {
                reqIsOpen:false,

                isDialogue:false
            }
        },
        components: {
            Carac,
            Addcarac
        },
        props: ['config'],
        computed: {
            getReq(){
                return this.config.requis
            },
            canBeDialogue(){
                return !this.isDialogue
            }

        },
        methods: {

            saveIt: _.debounce(function (){
                    this.validate()
                }, 1000),


            async validate()
            {
                this.$notification.open('SAUVEGARDE!!')

                await this.$store.dispatch('upTask',this.config)
            },

            async dialoguePanel(){
                this.config.type="DIAL"

                await this.$mydb.do.setResultatOutOfToDIAL(this.config.id)


                //switch sidebar
                const toEdit={
                    name:'TabDialogue',
                    config:this.config
                }
                this.$store.commit('DROITE_SET',toEdit);
            },

            async reloadMe(){
                // ya un truc qui a changé ailleur, te casse pas, reload le resultat
                const newVersion=await this.$mydb.do.getTask(this.config.id)

                //scrountch
                this.config.data=newVersion.data
            },

            async deleteTache(){
                try {

                    await this.$store.dispatch('delTask',this.config.id)

                    //switch sidebar
                    const toEdit={
                        name:'TabHelp',
                        config:''
                    }
                    this.$store.commit('DROITE_SET',toEdit);
                }
                catch(e) {
                    console.log("Erreur:" + e)
                }
            },

            async addReq(carac){
                const done=await this.$mydb.do.saveCarac(carac)

                //clef unique donc gestion d'une erreur de promesse rejettée
                if(done){
                    this.config.requis.push(carac.clef)
                    this.validate()
                }
                else {
                    this.alertCustomError("ERREUR ! <br>Cette clef existe déjà pour cet élément précis...")
                }
                this.$refs.addrequis.toggle()
            },
            delReq(evt){
                this.config.requis=this.config.requis.filter( thing => (thing !== evt ))
                this.saveIt()

            },

            focusReqOn() {
                this.reqIsOpen=true
            },
            focusReqOff() {
                this.reqIsOpen=false
            },
            alertCustomError(msg) {
                this.$dialog.alert({
                    title: 'Error',
                    message: msg,
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'alert-circle-outline',
                    iconPack: 'mdi'
                })
            },

        },
        mounted(){
            this.$refs.startFocus.focus()

        }
    }

</script>


<style lang="scss">
    .button{
        margin-bottom: 3px !important;
    }

</style>